import {
  Aperture,
  CloudFog,
  Database,
  HelpCircle,
  Landmark,
  Pickaxe,
  Swords,
} from "lucide-react";
import type { SignatureGroup } from "../types/chain";

const ICONS: Record<SignatureGroup, typeof Aperture> = {
  wormhole: Aperture,
  relic: Landmark,
  data: Database,
  gas: CloudFog,
  combat: Swords,
  ore: Pickaxe,
  unknown: HelpCircle,
};

export function SignatureGroupIcon({
  group,
  size = 14,
}: {
  group: SignatureGroup;
  size?: number;
}) {
  const Icon = ICONS[group];
  return <Icon size={size} aria-hidden />;
}
